module.exports = __webpack_public_path__ + "img/mt.1f800e79.png";